export const ANIM_CONFIG = {
  duration: 250
};
